import { UserAvatarComponent } from "../components/user-avatar-component";
import {
	Box,
	Button,
	FormControlLabel,
	Paper,
	Switch,
	Typography,
} from "@mui/material";
import { ProfileForm_USER } from "../forms/form-components/user-profile.form";
import { useCentralStore } from "../store/Central";
import { Check } from "lucide-react";
import { supabase } from "@/lib/supabase";
import { SupabaseTableEnum } from "@/lib/supabase/supabaseTypes";
import { RolesEnum } from "../types/enums";
import { showNotification } from "../store/Central/selectors";

export const AccountPage: React.FC = () => {
	const handleSignOut = useCentralStore((state) => state.handleSignOut);
	const { setMFADialog, mfaEnrolled, mfaVerified, role, organization } =
		useCentralStore((state) => ({
			setMFADialog: state.setMFADialog,
			mfaEnrolled: state.mfaEnrolled,
			mfaVerified: state.mfaVerified,
			role: state.role,
			organization: state.organization,
		}));
	if (!mfaVerified) return null;

	const toggleAnalytics = async () => {
		if (!organization?.id) return;

		const { error } = await supabase
			.from(SupabaseTableEnum.ORGANIZATIONS)
			.update({
				is_analytics: !organization?.is_analytics,
			})
			.eq("id", organization?.id);
		if (error) {
			showNotification({
				message:
					"Fehler beim Ändern der Analyse-Einstellungen. Sollte das Problem anhalten, melden Sie sich bitte bei unserem Support.",
				type: "error",
			});
		} else {
			// reload the page so the state is reflected globally and the script tag is updated accordingly
			window.location.reload();
		}
	};
	return (
		<div style={{ marginTop: 6 }}>
			<div className="flex items-center justify-between pr-8">
				<Typography sx={{ m: "30px" }} variant="h4" gutterBottom>
					Kontoeinstellungen
				</Typography>

				{!mfaEnrolled ? (
					<Button onClick={() => setMFADialog(true)} className="">
						Mehrfaktor-Authentifizierung einrichten
					</Button>
				) : (
					<div className=" flex gap-2 items-center bg-green-100 text-green-700 rounded p-2 ">
						<span>
							<Check size={22} />
						</span>
						<span>Mehrfaktor-Authentifizierung eingerichtet</span>
					</div>
				)}
			</div>
			<Paper sx={{ p: "30px" }}>
				<div
					style={{
						marginBottom: "20px",
						marginTop: "20px",
						display: "flex",
						justifyContent: "space-between",
					}}
				>
					<UserAvatarComponent />
					{role === RolesEnum.OWNER && (
						<FormControlLabel
							control={
								<Switch
									checked={organization?.is_analytics}
									onChange={toggleAnalytics}
								/>
							}
							sx={{
								fontSize: 10,
							}}
							label="Erlauben Sie das Sammeln anonymisierter Daten zur Verbesserung von dentLAB"
						/>
					)}
				</div>
				<ProfileForm_USER />
				<Button
					sx={{ my: 5 }}
					size="small"
					variant="outlined"
					color="primary"
					onClick={handleSignOut}
				>
					Ausloggen
				</Button>
			</Paper>
		</div>
	);
};
